import type { TextData } from '../dto/EntityRepository';
import {
  MARQUEE_GESTURE_MIN_PX,
  type MarqueeDragState,
  marqueeDragToBox,
} from './workListMarqueeUtils';

export { MARQUEE_GESTURE_MIN_PX, type MarqueeDragState, marqueeDragToBox };

/** 스크롤 컨테이너 좌표계 기준 박스와 겹치는 Text 행 id, DOM 순 */
export function collectTextIdsInMarquee(
  container: HTMLElement,
  box: { left: number; top: number; width: number; height: number }
): string[] {
  const marqRight = box.left + box.width;
  const marqBottom = box.top + box.height;
  const cRect = container.getBoundingClientRect();
  const out: string[] = [];
  container.querySelectorAll<HTMLElement>('[data-text-id]').forEach((marqueeEl) => {
    const r = marqueeEl.getBoundingClientRect();
    const left = r.left - cRect.left + container.scrollLeft;
    const top = r.top - cRect.top + container.scrollTop;
    const right = left + r.width;
    const bottom = top + r.height;
    if (box.left < right && marqRight > left && box.top < bottom && marqBottom > top) {
      const id = marqueeEl.dataset.textId;
      if (id) out.push(id);
    }
  });
  return out;
}

export function collectTextsInMarquee(
  container: HTMLElement,
  box: { left: number; top: number; width: number; height: number },
  textList: TextData[]
): TextData[] {
  const byId = new Map<string, TextData>();
  for (const t of textList) {
    byId.set(String(t.id), t);
  }
  return collectTextIdsInMarquee(container, box)
    .map((id) => byId.get(String(id)))
    .filter((t): t is TextData => !!t);
}
